
// SVG Icon: radio-off
export default { id: "terriajs-radio-off" };
export const id = "terriajs-radio-off";
export const name = "radio-off";
